
import React from 'react'
import useRazorpay from "react-razorpay";
import { useDispatch, useSelector } from "react-redux";

const useHandleRazorPayment = () => {
    const dispatch = useDispatch();
    const [Razorpay, isLoaded] = useRazorpay();
    const userData = useSelector((state) => state.userData.userData);

    const handlePayment = React.useCallback(
        async ({ packageAmount, songId, promotionData, packages, demoName, songName }) => {
            if (!promotionData?.id) {
                console.error("Missing promotionData.id, cannot proceed with payment");
                return;
            }

            const formData = new FormData();
            // formData.append("amount", packageAmount?.PackageAmount || packages?.PackageAmount);
            formData.append("amount", packageAmount?.PackageAmount || packageAmount || packages?.PackageAmount);
            formData.append("campaign_id", promotionData?.id);
            // formData.append("song_name", songId?.songTitle || demoName || songName);
            formData.append("song_name",
                songId?.songTitle || songId?.audio_name || demoName || songName || promotionData?.songName || promotionData?.demoName
            );


            try {
                const response = await fetch(process.env.REACT_APP_MUZICNETWORK_URL, {
                    method: "POST",
                    body: formData,
                });

                const data = await response.json();

                if (!data?.razorpay_order_id) {
                    throw new Error("Failed to create order");
                }

                const order = data?.razorpay_order_id;
                const callbackUrl = data?.callback_url;

                const options = {
                    key: process.env.REACT_APP_RAZOR_PAY_KEY,
                    amount: packageAmount?.PackageAmount,
                    currency: "INR",
                    name: "GNTunes",
                    description: "Paying for Campaign",
                    order_id: order,
                    callback_url: callbackUrl,
                    redirect: true,
                    allow_rotation: true,
                    prefill: {
                        name: userData.name,
                        email: userData.email,
                        contact: userData.contactNumber,
                    },
                    notes: {
                        address: "Razorpay Corporate Office",
                    },
                    theme: {
                        color: "#C61414",
                    },
                    modal: {
                        ondismiss: function () {
                            console.log("Payment modal dismissed");
                        },
                    },
                };

                const rzpay = new Razorpay(options);
                // ✅ Listen for payment failure
                rzpay.on("payment.failed", function (response) {
                    console.error("Payment failed:", response.error);
                    // Redirect to your failed payment page
                    window.location.href = "/payment_failed";
                });
                rzpay.open();
            } catch (error) {
                console.error("Error processing payment:", error);
            }
        },
        [Razorpay, isLoaded, userData, dispatch]
    );

    return handlePayment;
};

export default useHandleRazorPayment;
